import moment from 'moment';
import React, { useEffect } from 'react';
import { Card, Col, Container, Row } from 'react-bootstrap';
import API from '../common/API';
import { parsedUser } from '../common/GetCurrentUser';
const AgentVisitsPage = () => {
    const [agentId, setAgentId] = React.useState<string>('');
    const user = parsedUser();
    const [startDate, setStartDate] = React.useState<string>(moment().subtract(30, 'days').format('YYYY-MM-DD'));
    const [endDate, setEndDate] = React.useState<string>(moment().format('YYYY-MM-DD'));
    const [isLoading, setIsLoading] = React.useState<boolean>(false);
    const [records, setRecords] = React.useState<any[]>([]);

    const bindData = async () => {
        try {

            let query = `organizationId=${user.OrganizationId}&agentId=${agentId}&startDate=${startDate}&endDate=${endDate}`;
            setIsLoading(true);
            const request = await API.getAction(`reports/agentVisits?${query}`);
            if (request.data.status === "ok") {
                setRecords(request.data.response);
            }
        } catch (e) {
            // Error handled - agent visits fetch failed
        }
        finally {
            setIsLoading(false);
        }

    }
    useEffect(() => {

        bindData();
    }, []);
    return (
        <Container>
            <Card className='my-4'>
                <Card.Header>
                    <Card.Title>Reporte de Visitas por Agentes</Card.Title>
                </Card.Header>
                <Card.Body>
                    <Row>

                        <Col className='col-md-4 col-12'>
                            <label>Desde</label>
                            <input type="date" className='form-control' value={startDate} onChange={e => {
                                setStartDate(moment(e.target.value).format('YYYY-MM-DD'));
                            }} />
                        </Col>
                        <Col className='col-md-4 col-12'>
                            <label>Hasta</label>  <input type="date" className='form-control' value={endDate} onChange={e => {
                                setEndDate(moment(e.target.value).format('YYYY-MM-DD'));
                            }} />
                        </Col>
                    </Row>
                </Card.Body>
                <Card.Footer>
                    <button className='btn btn-primary' disabled={isLoading} onClick={() => bindData()}>Generar Reporte</button>
                </Card.Footer>
            </Card>
            <Card>
                <Card.Body>
                    <div className='table-responsive'>
                        <table className='table table-striped'>
                            <thead>
                                <tr>
                                    <th>Agente</th>
                                    <th className='text-end'>Asignados</th>
                                    <th className='text-end'>Estatus: Venta</th>
                                    <th className='text-end'>Visitados</th>
                                    <th className='text-end'>Sin Visita</th>
                                    <th className='text-end'>Visitados en el periodo</th>
                                </tr>
                            </thead>
                            <tbody>
                                {records && records.map((record, index) => (
                                    <tr key={index}>
                                        <td>{record.agentName ?? '—'}</td>
                                        <td className='text-end'>{record.totalAssigned ?? 0}</td>
                                        <td className='text-end'>{record.totalInSale ?? '—'}</td>
                                        <td className='text-end'>{record.totalVisited ?? 0}</td>
                                        <td className='text-end'>{record.totalNotVisited ?? 0}</td>
                                        <td className='text-end'>{record.totalVisitedInPeriod ?? 0}</td>
                                    </tr>
                                )
                                )}
                            </tbody>
                        </table>
                    </div>
                </Card.Body>
            </Card>
        </Container>
    );
}
export default AgentVisitsPage;